<template lang="pug">
  .criteria-modification-wrap
    .criteria
      .criteria__body
        .filter-label
          p Filter by:
        lei-filter(
          v-for="(params, index) in criteriaBase()"
          select
          :key="index"
          :dropdown-mode="params.dropdownMode"
          :class="params.className"
          :index="index"
          :items="params.items"
          :disabled="params.disabled"
          :initial-value="params.initialValue"
          :chosenField="params.chosenField"
          :name="params.label"
          @choose="params.select"
          @remove="$emit('clear')"
          :get-label="params.getLabel")
        lei-btn.clear-btn(@click="$emit('clear')",  type="turquoise-keyline", size="sm", fill) Clear filter
</template>
<script>
import { mapGetters, mapMutations, mapState, } from 'vuex'
import { SET_CRITERIA_MODIFICATION, RESET_CRITERIA_MODIFICATION, } from '@/store/modules/record/mutations-types'
import { getInputType, } from '@/utils/criteria'

import InputCreator from '@/components/lei-components/inputs/InputCreator'
import LeiFilter from '@/components/lei-components/inputs/LeiFilter'
import LeiBtn from '@/components/lei-components/LeiBtn'

export default {
  components: {
    InputCreator,
    LeiFilter,
    LeiBtn,
  },
  data () {
    return {
      chosenField: [],
    }
  },
  computed: {
    ...mapState('record', [ 'criteriaModifications', 'modificationType', ]),
    ...mapGetters('search', [ 'getFieldsByType', ]),
  },
  methods: {
    enter () {
      this.$emit('enter')
    },
    getFieldsItems (fields, relationship) {
      return fields && fields.length !== 0 ? fields : this.getFieldsByType({
        context: relationship.id,
        type: this.modificationType,
      })
    },
    selectField ({ item, index, }) {
      this.chosenField[index] = item.id
      this.setCriteriaObject({
        field: item,
        dataType: getInputType(item.data_type),
        value: '',
        operators: item.operators,
      })
      this.enter()
    },
    setCriteriaObject (criteria) {
      this.setCriteriaModification(criteria)
    },
    criteriaBase () {
      const { relationship, field, fields, } = this.criteriaModifications
      return [
        {
          label: '',
          className: 'fields',
          items: this.getFieldsItems(fields, relationship),
          initialValue: field,
          chosenField: this.chosenField,
          getLabel: (item) => item.label,
          select: this.selectField,
        },
      ]
    },

    ...mapMutations('record', {
      setCriteriaModification: SET_CRITERIA_MODIFICATION,
      resetCriteriaModification: RESET_CRITERIA_MODIFICATION,
    }),
  },
}
</script>
<style lang="stylus">
@import "../../../assets/styles/variables.styl"

$local-font-size = .85rem

.criteria-modification-wrap
  max-width: 590px
  margin: 0 auto

  .criteria
    &__body
      display: grid
      grid-template-columns: max-content 1fr max-content

      .filter-label
        align-self: center
        margin-right: 10px
        font-weight: 600
        font-size: $local-font-size
        color: $default-color-bold

      .clear-btn
        align-self: center

      .lei-filter.select
        margin-bottom 0
        .button-wrap
          .category
            display none !important

@media screen and (max-width: $tablet)
  .criteria-modification-wrap
    .criteria
      &__body
        grid-template-columns: 1fr

        .filter-label
          margin: 20px 0 10px
        .clear-btn
          margin-top 20px

        .lei-filter.select
          .button-wrap
            .category
              display flex !important

@media screen and (max-width: $laptop-l) and (min-width: $laptop-min)
  .criteria-modification-wrap
    .criteria
      margin-bottom: 10px

      .lei-filter.select
        &.search-input
          margin 0 0 10px
        .button-wrap
          .select-block
            font-size  $local-font-size
            height $input-sm
            padding 5px 30px 5px 10px

</style>



// WEBPACK FOOTER //
// src/components/record-details/modifications/ModificationCriteria.vue